import { fillAssetFinanceFinanceProposal } from '__core/shared/util/salestrekker';
import template from './financeProposalQuickQuote.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    quickQuoteAssetDetails: '<',
    quickQuoteFinanceProposal: '<',
    quickQuoteSearchFields: '<',
    quickQuoteSelectedProduct: '<',
    workflow: '<',
    contacts: '<',
    lenders: '<',
    ticket: '<',
    financeProposalParams: '<',
    isCommercial: '<',
    isQuickQuoteUnsecured: '<',
    isTicketSettled: '<',
    onSearchStarted: '&',
    onResetListOfSearchProducts: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $timeout,
      $mdUtil,
      $mdMedia,
      $mdMenu,
      $mdDialog,
      eventService,
      helperService,
      dateTimeService,
      assetFinanceService,
      ticketFactFindService,
      AssetFinanceSearchProduct,
      financesService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.mdMenu = $mdMenu;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
      ctrl.currentLocale = $rootScope.CurrentLocale();
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availableTermInMonths = [];
      ctrl.availableLoanTypes = [];
      ctrl.availableProductTypes = [];
      ctrl.availablePaymentFrequencies = [];
      ctrl.availableAssetFinanceProposalAssociatedFeeTypes = [];
      ctrl.availableElapsedTimeFromPayout = [];
      ctrl.availableElapsedTermOldLoan = [];
      ctrl.availableIncreaseInRepayment = [];
      ctrl.availableAssetFinanceEmploymentBasis = [];
      ctrl.availableCreditHistories = [];
      ctrl.availableAbnRegistered = [];
      ctrl.availableGstRegistered = [];
      ctrl.availableHomeOwnership = [];
      ctrl.availableTimeAtCurrentAddress = [];
      ctrl.availableTimeInEmployment = [];
      ctrl.availableBankrupts = [];
      ctrl.availableFinancialDefaults = [];
      ctrl.availableUtilityAndTelCo = [];
      ctrl.availablePayDayEnquires = [];
      ctrl.availablePayDayOnStatements = [];
      ctrl.availableDepositRequired = [];
      ctrl.availableMaxNegativeEquity = [];
      ctrl.availableYesNoOption = [];
      ctrl.financeProposalParams = {};
      ctrl.isProcessing = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.availableTermInMonths = helperService.getAvailableTermInMonths({
          isRegular: true
        });
        ctrl.availableElapsedTimeFromPayout = assetFinanceService.getAvailableElapsedTimeFromPayout();
        ctrl.availableElapsedTermOldLoan = assetFinanceService.getAvailableElapsedTermOldLoan();
        ctrl.availableIncreaseInRepayment = assetFinanceService.getAvailableIncreaseInRepayment();
        ctrl.availableAssetFinanceEmploymentBasis = assetFinanceService.getAvailableAssetFinanceEmploymentBasis();
        ctrl.availableAbnRegistered = assetFinanceService.getAvailableAbnRegistered();
        ctrl.availableGstRegistered = assetFinanceService.getAvailableGstRegistered();
        ctrl.availableHomeOwnership = assetFinanceService.getAvailableHomeOwnership();
        ctrl.availableTimeAtCurrentAddress = assetFinanceService.getAvailableTimeAtCurrentAddress();
        ctrl.availableTimeInEmployment = assetFinanceService.getAvailableTimeInEmployment();
        ctrl.availableBankrupts = assetFinanceService.getAvailableBankrupts();
        ctrl.availableFinancialDefaults = assetFinanceService.getAvailableFinancialDefaults();
        ctrl.availableUtilityAndTelCo = assetFinanceService.getAvailableUtilityAndTelCo();
        ctrl.availablePayDayEnquires = assetFinanceService.getAvailablePayDayEnquires();
        ctrl.availablePayDayOnStatements = assetFinanceService.getAvailablePayDayOnStatements();
        ctrl.availableDepositRequired = assetFinanceService.getAvailableDepositRequired();
        ctrl.availableMaxNegativeEquity = assetFinanceService.getAvailableMaxNegativeEquity();
        ctrl.availableYesNoOption = assetFinanceService.getAvailableYesNoOption();
        ctrl.quickQuoteAssetDetails = ctrl.quickQuoteAssetDetails || [];
        ctrl.quickQuoteFinanceProposal = ctrl.quickQuoteFinanceProposal || {};
        ctrl.quickQuoteSearchFields = ctrl.quickQuoteSearchFields || {};
        ctrl.quickQuoteSelectedProduct = ctrl.quickQuoteSelectedProduct || {};
        ctrl.workflow = ctrl.workflow || {};
        ctrl.contacts = ctrl.contacts || [];
        ctrl.companies = _.filter(ctrl.contacts, (c) => c?.isCompany);
        ctrl.lenders = ctrl.lenders || [];
        ctrl.ticket = ctrl.ticket || {};
        ctrl.assets = ctrl.ticket?.assets || [];
        ctrl.liabilities = ctrl.ticket?.liabilities || [];
        ctrl.ticketDate = ctrl.ticket?.values?.onceOffDueDate || dateTimeService.epoch();
        ctrl.financeProposalParams = ctrl.financeProposalParams || {};
        ctrl.isCommercial = ctrl.isCommercial || false;
        ctrl.isQuickQuoteUnsecured = ctrl.isQuickQuoteUnsecured || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.availableLoanTypes = assetFinanceService.getAvailableLoanTypes(ctrl.isCommercial);
        ctrl.availablePaymentFrequencies = helperService.getAvailablePaymentFrequencies({
          workflow: ctrl.workflow,
          loanPurpose: ctrl.isCommercial ? 'commercial' : 'consumer'
        });
        ctrl.availableCreditHistories = assetFinanceService.getAvailableCreditHistories(
          ctrl.isCommercial
        );
        if (!ctrl.quickQuoteFinanceProposal?.isEdit) {
          ctrl.quickQuoteFinanceProposal.isEdit = true;
          ctrl.saveQuickQuoteFinanceProposal(true);
        }
        ctrl.quickQuoteSearchFields.idLenders = _.map(ctrl.lenders || [], 'id');
        ctrl.setAvailableProductTypes();
        ctrl.setTotalAssetCostInfo();
        if (ctrl.ticket?.id) {
          eventService.assetFinanceQuickQuoteProcessing({ isProcessing: true });
          ctrl.getSetFinanceProposal();
        }
        ctrl.isReady = true;
      };

      ctrl.setAvailableProductTypes = () => {
        ctrl.availableProductTypes = assetFinanceService.getAvailableProductTypes({
          isCommercial: ctrl.isCommercial
        });
        if (ctrl.isCommercial) {
          const canSelectLease = assetFinanceService.canSelectLease(
            ctrl.quickQuoteAssetDetails
          );
          for (let i = 0; i < ctrl.availableProductTypes.length; i += 1) {
            if (
              ctrl.availableProductTypes[i].id === 2 ||
              ctrl.availableProductTypes[i].id === 3 ||
              ctrl.availableProductTypes[i].id === 7
            ) {
              ctrl.availableProductTypes[i].isDisabled = !canSelectLease;
            }
          }
        } else {
          ctrl.quickQuoteFinanceProposal.productType = ctrl.availableProductTypes[0].id;
        }
      };

      ctrl.setTotalAssetCostInfo = () => {
        ctrl.totalAssetCostInfo = _.reduce(
          ctrl.quickQuoteAssetDetails || [],
          (memo, num) => _.add(memo + _.toNumber(num?.costInfo || 0)),
          0
        );
      };

      ctrl.setSearchFields = () => {
        let assetAge = -1;
        if (ctrl.quickQuoteAssetDetails?.length) {
          const currentYear = parseInt(moment.utc().startOf('day').year() || 0, 10);
          const buildYear = parseInt(ctrl.quickQuoteAssetDetails[0]?.vehicle?.year || 0, 10);
          if (currentYear && buildYear) {
            assetAge = currentYear <= buildYear ? 0 : currentYear - buildYear;
          }
        }
        const totalAssetNetCost = _.reduce(
          ctrl.quickQuoteAssetDetails,
          (sum, n) => _.add(sum, helperService.isNumber(n?.netCost, true)),
          0
        );
        ctrl.quickQuoteSearchFields.loanAmount =
          ctrl.quickQuoteFinanceProposal?.totalAssetNetCost || totalAssetNetCost;
        ctrl.quickQuoteSearchFields.assetType = ctrl.quickQuoteAssetDetails[0]?.type || 0;
        ctrl.quickQuoteSearchFields.assetAge = assetAge;
        ctrl.quickQuoteSearchFields.loanTerm = ctrl?.quickQuoteFinanceProposal?.term || 0;
        ctrl.quickQuoteSearchFields.productType =
          ctrl?.quickQuoteFinanceProposal?.productType || 0;
        ctrl.quickQuoteSearchFields.vendorType =
          ctrl.quickQuoteAssetDetails[0]?.vendor?.type || 0;
        ctrl.quickQuoteSearchFields.balloonValue =
          ctrl?.quickQuoteFinanceProposal?.balloonValue || 0;
        ctrl.quickQuoteSearchFields.balloonPercent =
          ctrl?.quickQuoteFinanceProposal?.balloonPercent || 0;
        ctrl.quickQuoteSearchFields.brokerOriginationFee =
          ctrl?.quickQuoteFinanceProposal?.brokerOriginationFee || 0;
        ctrl.quickQuoteSearchFields.brokerCommissionValue = ctrl.isCommercial
          ? ctrl?.quickQuoteFinanceProposal?.brokerCommissionValue || 0
          : 0;
        ctrl.quickQuoteSearchFields.brokerCommissionPercent =
          ctrl.isCommercial && ctrl.quickQuoteSearchFields?.loanAmount
            ? _.multiply(
                _.divide(
                  ctrl?.quickQuoteFinanceProposal?.brokerCommissionValue || 0,
                  ctrl.quickQuoteSearchFields.loanAmount
                ),
                100
              )
            : 0;

        if (ctrl.isQuickQuoteUnsecured) {
          ctrl.quickQuoteSearchFields.assetType = ctrl.isCommercial
            ? ctrl.availableAssetTypes[37].id
            : ctrl.availableAssetTypes[11].id;
          ctrl.quickQuoteSearchFields.assetAge = -1;
          ctrl.quickQuoteSearchFields.vendorType = 0;
          ctrl.quickQuoteSearchFields.balloonValue = 0;
          ctrl.quickQuoteSearchFields.balloonPercent = 0;
          ctrl.quickQuoteSearchFields.lvrLvt = 0;
          ctrl.quickQuoteSearchFields.integrationLvrLvt = 0;
        }

        ctrl.quickQuoteSearchFields.loanType = ctrl.isCommercial
          ? ctrl.quickQuoteSearchFields.loanType
          : 'FULL_DOC';
        ctrl.quickQuoteSearchFields.creditScore =
          !ctrl.isCommercial && !ctrl.quickQuoteSearchFields?.creditScore
            ? parseFloat(ctrl.contacts[0]?.creditScore[0]?.score || 0)
            : ctrl.quickQuoteSearchFields?.creditScore || 0;
        ctrl.quickQuoteSearchFields.abnRegistered = !ctrl.quickQuoteSearchFields.abnRegistered
          ? assetFinanceService.setInitialValueOfAbnRegistered({
              company: ctrl.companies[0]
            })
          : ctrl.quickQuoteSearchFields.abnRegistered;
        ctrl.quickQuoteSearchFields.gstRegistered = !ctrl.quickQuoteSearchFields.gstRegistered
          ? assetFinanceService.setInitialValueOfGstRegistered({
              company: ctrl.companies[0]
            })
          : ctrl.quickQuoteSearchFields.gstRegistered;
        ctrl.quickQuoteSearchFields.homeOwnership = !ctrl.quickQuoteSearchFields.homeOwnership
          ? assetFinanceService.setInitialValueOfPropertyOwnership({
              assets: ctrl.assets,
              liabilities: ctrl.liabilities
            })
          : ctrl.quickQuoteSearchFields.homeOwnership;
      };

      ctrl.getSetFinanceProposal = () => {
        ctrl.availableAssetFinanceProposalAssociatedFeeTypes = assetFinanceService.getAvailableAssetFinanceAssociatedFeeTypes(
          { isQuickTool: true }
        );
        if (!ctrl.ticket?.id) {
          ctrl.financeProposalParams = {
            financeProposal: ctrl.quickQuoteFinanceProposal || {},
            selectedProduct: ctrl.quickQuoteSelectedProduct?.length
              ? ctrl.quickQuoteSelectedProduct[0] || {}
              : {},
            isCommercial: ctrl.isCommercial || false
          };
        }
        if (ctrl.quickQuoteSelectedProduct?.length) {
          financesService
            .assetFinanceFinanceProposal({
              idTicket: ctrl.ticket?.id || '',
              financeProposalParams: ctrl.financeProposalParams,
              isQuote: true
            })
            .then((res) => {
              if (res?.status) {
                ctrl.quickQuoteFinanceProposal = fillAssetFinanceFinanceProposal(
                  ctrl.quickQuoteFinanceProposal || {},
                  res.financeProposal,
                  true
                );
                ctrl.quickQuoteFinanceProposal = assetFinanceService.prepareFinanceProposalAmortizationSchedules(
                  {
                    financeProposal: ctrl?.quickQuoteFinanceProposal,
                    ticketDate: ctrl.ticketDate
                  }
                );
                ctrl.setSearchFields();
                ctrl.toggleFinanceProposalAssociatedFees(true);
              }
              eventService.assetFinanceQuickQuoteProcessing({ isProcessing: false });
            });
        } else {
          ctrl.toggleFinanceProposalAssociatedFees(true);
          eventService.assetFinanceQuickQuoteProcessing({ isProcessing: false });
        }
      };

      ctrl.toggleFinanceProposalAssociatedFees = (isSilent) => {
        if (!ctrl.quickQuoteFinanceProposal?.isAssociatedFeesEdited) {
          ctrl.quickQuoteFinanceProposal.associatedFees = assetFinanceService.setFinanceProposalAssociatedFees(
            {
              associatedFees: ctrl.quickQuoteFinanceProposal?.associatedFees || [],
              preferredProduct: ctrl.quickQuoteSelectedProduct[0] || {},
              isQuickTool: true
            }
          );
        }
        if (isSilent) {
          ctrl.saveQuickQuoteFinanceProposal(true);
        } else {
          ctrl.quickQuoteFinanceProposalChanges({});
        }
      };

      ctrl.isLeaseSelectedAsProductType = () =>
        assetFinanceService.isLeaseSelectedAsProductType({
          item: ctrl.quickQuoteFinanceProposal
        });

      ctrl.getOriginationMaxFee = () =>
        ctrl.quickQuoteSelectedProduct[0]?.assetFinance?.originationFeeMax.formatWithCurrency(
          ctrl.currentCurrency,
          2
        ) || (0).formatWithCurrency(ctrl.currentCurrency, 2);

      ctrl.getLender = () =>
        _.find(
          ctrl.lenders || [],
          (l) => l?.id === ctrl.quickQuoteSelectedProduct[0]?.lender[0]?.id
        );

      ctrl.getLenderName = () => ctrl.quickQuoteSelectedProduct[0]?.lender[0]?.name || 'N/A';

      ctrl.amortizationScheduleEdit = ($event) => {
        eventService.assetFinanceProposalAmortizationScheduleChange({
          event: $event,
          contacts: ctrl.contacts,
          financeProposal: angular.copy(ctrl.quickQuoteFinanceProposal),
          ticket: ctrl.ticket,
          ticketDate: ctrl.ticketDate,
          isCommercial: ctrl.isCommercial,
          isQuickTool: true
        });
      };

      ctrl.saveAmortizationSchedule = (financeProposal) => {
        ctrl.quickQuoteFinanceProposal = financeProposal;
        ctrl.saveQuickQuoteFinanceProposal(true);
      };

      ctrl.quickQuoteFinanceProposalAssociatedFeeAdd = ({ feeType }) => {
        if (!ctrl.quickQuoteFinanceProposal?.associatedFees) {
          ctrl.quickQuoteFinanceProposal.associatedFees = [];
        }
        ctrl.quickQuoteFinanceProposal.associatedFees = assetFinanceService.financeProposalAssociatedFeeAdd(
          {
            associatedFees: ctrl.quickQuoteFinanceProposal.associatedFees,
            feeType,
            showToast: true
          }
        );
      };

      ctrl.quickQuoteFinanceProposalAssociatedFeeDelete = (idx) => {
        helperService
          .deleteItem(
            ctrl.quickQuoteFinanceProposal.associatedFees,
            ctrl.quickQuoteFinanceProposal.associatedFees[idx],
            ctrl.quickQuoteFinanceProposal.associatedFees[idx].getName(),
            'Associated fee'
          )
          .then((result) => {
            if (result) {
              ctrl.quickQuoteFinanceProposalChanges({ action: 'changeNetAmountFinanced' });
            }
          });
      };

      ctrl.showPayments = (type) =>
        assetFinanceService.showFinanceProposalPaymentsOptionBySettingsOfSelectedProduct({
          selectedProduct: ctrl.quickQuoteSelectedProduct?.length
            ? ctrl.quickQuoteSelectedProduct[0]
            : undefined,
          type
        });

      ctrl.searchProducts = ($event) => {
        $event.preventDefault();
        eventService.assetFinanceQuickQuoteProcessing({ isProcessing: true });
        ctrl.onSearchStarted({ isSearchStarted: true });
      };

      ctrl.showWarning = () =>
        !ctrl.quickQuoteFinanceProposal.netAmountFinanced ||
        !ctrl.quickQuoteFinanceProposal.term ||
        !ctrl.quickQuoteFinanceProposal.productType ||
        (ctrl.isCommercial && !ctrl.quickQuoteSearchFields.loanType);

      ctrl.isMacqSelectedAsLenderAndFeeTypeMarkedAsPpsr = ({ feeType }) =>
        assetFinanceService.isMacqSelectedAsLenderAndFeeTypeMarkedAsPpsr({
          product: ctrl.quickQuoteSelectedProduct[0] || {},
          feeType,
          isQuickTool: true
        });

      ctrl.getBrokerCommissionLabelName = ({ isPercent }) => {
        let labelName = `Broker commission ${isPercent ? 'percent' : 'value'} (net of GST)`;
        if (ctrl.quickQuoteSelectedProduct[0]?.assetFinance?.brokerCommission === 4) {
          labelName = `Broker commission ${isPercent ? 'percent' : 'value'} (including GST)`;
        }
        if (
          assetFinanceService.isProductTypeLeaseAndAnzLender({
            product: ctrl.quickQuoteSelectedProduct[0] || {},
            financeProposal: ctrl.quickQuoteFinanceProposal || {},
            isQuickTool: true
          })
        ) {
          labelName = `Broker commission ${isPercent ? 'percent' : 'value'}`;
        }
        return labelName;
      };

      ctrl.brokerCommissionCase = () => {
        if (ctrl.quickQuoteSelectedProduct?.length) {
          return (
            ctrl.quickQuoteSelectedProduct[0]?.assetFinance?.brokerCommission !== 1 &&
            ctrl.quickQuoteSelectedProduct[0]?.assetFinance?.brokerCommission !== 4 &&
            ctrl.quickQuoteSelectedProduct[0]?.assetFinance?.brokerCommission !== 6 &&
            ctrl.quickQuoteSelectedProduct[0]?.assetFinance?.brokerCommission !== 10
          );
        }
        return false;
      };

      ctrl.isBrokerOriginationFeeDisabled = () =>
        (ctrl.quickQuoteSelectedProduct[0]?.assetFinance?.brokerCommission === 8 ||
          ctrl.quickQuoteSelectedProduct[0]?.assetFinance?.brokerCommission === 9 ||
          ctrl.quickQuoteSelectedProduct[0]?.assetFinance?.brokerCommission === 10 ||
          ctrl.quickQuoteSelectedProduct[0]?.assetFinance?.brokerCommission === 11) &&
        !ctrl.quickQuoteSelectedProduct[0]?.productDetails?.isUpfrontFeeCapitalised;

      ctrl.hasSelectedProduct = () =>
        ctrl.quickQuoteSelectedProduct?.length && !_.isEmpty(ctrl.quickQuoteSelectedProduct[0]);

      ctrl.resetQuickQuoteFinanceProposalPricingFields = () => {
        if (!ctrl.isCommercial) {
          ctrl.quickQuoteFinanceProposal.brokerOriginationFee = 0;
          ctrl.quickQuoteFinanceProposal.brokerCommissionValue = 0;
          ctrl.quickQuoteFinanceProposal.brokerCommissionPercent = 0;
        }
        ctrl.quickQuoteFinanceProposal.interestRate = 0;
        ctrl.quickQuoteFinanceProposal.isInterestRateEdited = false;
        ctrl.quickQuoteFinanceProposal.estimatedBorrowerRate = 0;
        ctrl.quickQuoteFinanceProposal.estimatedRepayment = 0;
        ctrl.quickQuoteFinanceProposal.estimatedRepaymentBuffer = 0;
      };

      ctrl.showProcessingAndBrokerFees = () =>
        !ctrl.isCommercial &&
        ctrl.quickQuoteSelectedProduct?.length &&
        ($rootScope.isDev() || $rootScope.isPtf() || $rootScope.isNlg());

      ctrl.quickQuoteFinanceProposalChanges = ({ action }) => {
        if (!ctrl.quickQuoteSelectedProduct?.length) {
          ctrl.onResetListOfSearchProducts();
        }
        if (
          !_.isEmpty(ctrl.quickQuoteSearchFields) &&
          !_.isEmpty(ctrl.quickQuoteFinanceProposal)
        ) {
          switch (action) {
            case 'changeBalloonPercent':
              ctrl.quickQuoteFinanceProposal.balloonValue = assetFinanceService.setValueOrPercent(
                {
                  amount: ctrl.quickQuoteFinanceProposal?.totalAssetCost || 0,
                  percent: ctrl.quickQuoteFinanceProposal?.balloonPercent || 0
                }
              );
              break;
            case 'changeBalloonValue':
              ctrl.quickQuoteFinanceProposal.balloonPercent = assetFinanceService.setValueOrPercent(
                {
                  amount: ctrl.quickQuoteFinanceProposal?.totalAssetCost || 0,
                  value: ctrl.quickQuoteFinanceProposal?.balloonValue || 0
                }
              );
              break;
            case 'changeBrokerCommissionPercent':
              ctrl.quickQuoteFinanceProposal.brokerCommissionValue = assetFinanceService.setValueOrPercent(
                {
                  amount: ctrl.quickQuoteFinanceProposal?.netAmountFinanced || 0,
                  percent: ctrl.quickQuoteFinanceProposal?.brokerCommissionPercent || 0
                }
              );
              break;
            case 'changeBrokerCommissionValue':
              ctrl.quickQuoteFinanceProposal.brokerCommissionPercent = assetFinanceService.setValueOrPercent(
                {
                  amount: ctrl.quickQuoteFinanceProposal?.netAmountFinanced || 0,
                  value: ctrl.quickQuoteFinanceProposal?.brokerCommissionValue || 0
                }
              );
              break;
            case 'changeNetAmountFinanced':
              if (
                ctrl.quickQuoteFinanceProposal?.isNetAmountFinancedEdited &&
                ctrl.quickQuoteSelectedProduct?.length
              ) {
                ctrl.quickQuoteFinanceProposal.lvr = assetFinanceService.setLvrLvt({
                  amount: ctrl.quickQuoteFinanceProposal?.netAmountFinanced || 0,
                  total: ctrl.quickQuoteFinanceProposal?.totalAssetCost || 0
                });
                if (ctrl.isCommercial) {
                  ctrl.quickQuoteFinanceProposal.brokerCommissionValue = assetFinanceService.setValueOrPercent(
                    {
                      amount: ctrl.quickQuoteFinanceProposal?.netAmountFinanced || 0,
                      percent: ctrl.quickQuoteFinanceProposal?.brokerCommissionPercent || 0
                    }
                  );
                }
              }
              break;
            case 'changeLvrLvt':
              ctrl.quickQuoteFinanceProposal.netAmountFinanced =
                ctrl.quickQuoteSearchFields?.lvrLvt &&
                ctrl.quickQuoteFinanceProposal?.totalAssetCost
                  ? _.subtract(
                      _.multiply(
                        _.divide(ctrl.quickQuoteSearchFields.lvrLvt, 100),
                        ctrl.quickQuoteFinanceProposal.totalAssetCost
                      ),
                      ctrl.quickQuoteSearchFields?.brokerCommissionValue || 0
                    )
                  : 0;
              ctrl.quickQuoteSearchFields.integrationLvrLvt = assetFinanceService.setLvrLvt({
                amount: ctrl.quickQuoteFinanceProposal?.netAmountFinanced || 0,
                total: ctrl?.totalAssetCostInfo || 0
              });
              if (ctrl.isCommercial) {
                ctrl.quickQuoteFinanceProposal.brokerCommissionValue = assetFinanceService.setValueOrPercent(
                  {
                    amount: ctrl.quickQuoteFinanceProposal?.netAmountFinanced || 0,
                    percent: ctrl.quickQuoteFinanceProposal?.brokerCommissionPercent || 0
                  }
                );
              }
              break;
            case 'changeIntegrationLvrLvt':
              ctrl.quickQuoteSearchFields.netAmountFinanced =
                ctrl.quickQuoteSearchFields?.integrationLvrLvt && ctrl.totalAssetCostInfo
                  ? _.subtract(
                      _.multiply(
                        _.divide(ctrl.quickQuoteSearchFields.integrationLvrLvt, 100),
                        ctrl.totalAssetCostInfo
                      ),
                      ctrl.quickQuoteSearchFields?.brokerCommissionValue || 0
                    )
                  : 0;
              ctrl.quickQuoteSearchFields.lvrLvt = assetFinanceService.setLvrLvt({
                amount: ctrl.quickQuoteFinanceProposal?.netAmountFinanced || 0,
                total: ctrl?.totalAssetCost || 0
              });
              if (ctrl.isCommercial) {
                ctrl.quickQuoteFinanceProposal.brokerCommissionValue = assetFinanceService.setValueOrPercent(
                  {
                    amount: ctrl.quickQuoteFinanceProposal?.netAmountFinanced || 0,
                    percent: ctrl.quickQuoteFinanceProposal?.brokerCommissionPercent || 0
                  }
                );
              }
              break;
            case 'loanType':
              if (ctrl.quickQuoteSearchFields?.loanType !== 'REPLACEMENT_POLICY') {
                ctrl.quickQuoteSearchFields.likeForLike = 'NOT_ESSENTIAL';
                ctrl.quickQuoteSearchFields.changeToEntityAllowed = 'NOT_ESSENTIAL';
                ctrl.quickQuoteSearchFields.elapsedTimeFromPayout = 'NOT_ESSENTIAL';
                ctrl.quickQuoteSearchFields.elapsedTermOldLoan = 'NOT_ESSENTIAL';
                ctrl.quickQuoteSearchFields.increaseInRepayment = 'NOT_ESSENTIAL';
              }
              break;
            default:
              break;
          }
        }
        ctrl.qQFPChanges();
      };

      ctrl.qQFPChanges = _.debounce(() => {
        ctrl.setSearchFields();
        ctrl.saveQuickQuoteFinanceProposal();
      }, 3000);

      ctrl.saveQuickQuoteFinanceProposal = (isSilent) => {
        if (!ctrl.quickQuoteSelectedProduct?.length) {
          ctrl.resetQuickQuoteFinanceProposalPricingFields();
        }
        if (!isSilent && ctrl.quickQuoteSelectedProduct?.length) {
          eventService.assetFinanceQuickQuoteProcessing({
            isProcessing: true
          });
        }
        const data = {
          quickQuoteFinanceProposal: ctrl.quickQuoteFinanceProposal,
          quickQuoteSearchFields: ctrl.quickQuoteSearchFields,
          aFCD:
            !isSilent && ctrl.quickQuoteSelectedProduct?.length
              ? 'assetFinanceQuickQuoteFinanceProposal'
              : ''
        };
        ctrl.onFinished({ data });
      };

      ctrl.destroyWatch = eventService.onChangedData((params) => {
        if (params?.changedData === 'assetFinanceQuickQuoteFinanceProposal') {
          eventService.assetFinanceQuickQuoteProcessing({ isProcessing: true });
          ctrl.getSetFinanceProposal();
        }
      });

      ctrl.destroyProcessingWatch = eventService.onAssetFinanceQuickQuoteProcessing(
        (params) => {
          ctrl.isProcessing = params?.isProcessing || false;
        }
      );

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onChanges = (changes) => {
        if (changes?.quickQuoteAssetDetails?.currentValue) {
          ctrl.setAvailableProductTypes();
          ctrl.setTotalAssetCostInfo();
        }
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
        ctrl.destroyProcessingWatch();
      };
    }
  }
};
